export default __webpack_public_path__ + "static/media/topologia.d728c674.png";